module.exports = __webpack_public_path__ + "82e7a9b21333bc9a8ce3dc834e68e410.woff";